import MediaGalleryVideoContainer from './MediaGalleryVideoContainer.js';
export default MediaGalleryVideoContainer;
//# sourceMappingURL=index.js.map